var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6533 8.23335C9.60667 5.51335 5.88 5.36668 6.78 1.41335C6.84667 1.12001 6.53334 0.893346 6.28 1.04668C3.86 2.47335 2.12 5.33335 3.58 9.08001C3.7 9.38668 3.34 9.67335 3.08 9.47335C1.87334 8.56001 1.74667 7.24668 1.85334 6.30668C1.89334 5.96001 1.44001 5.79335 1.24667 6.08001C0.793338 6.77335 0.333338 7.89335 0.333338 9.58001C0.586672 13.3133 3.74001 14.46 4.87334 14.6067C6.49334 14.8133 8.24667 14.5133 9.50667 13.36C10.8933 12.0733 11.4 10.02 10.6533 8.23335ZM4.46667 11.5867C5.42667 11.3533 5.92 10.66 6.05334 10.0467C6.27334 9.09335 5.41334 8.16001 5.99334 6.65335C6.21334 7.90001 8.17334 8.68001 8.17334 10.04C8.22667 11.7267 6.4 13.1733 4.46667 11.5867Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6533 8.23335C9.60667 5.51335 5.88 5.36668 6.78 1.41335C6.84667 1.12001 6.53334 0.893346 6.28 1.04668C3.86 2.47335 2.12 5.33335 3.58 9.08001C3.7 9.38668 3.34 9.67335 3.08 9.47335C1.87334 8.56001 1.74667 7.24668 1.85334 6.30668C1.89334 5.96001 1.44001 5.79335 1.24667 6.08001C0.793338 6.77335 0.333338 7.89335 0.333338 9.58001C0.586672 13.3133 3.74001 14.46 4.87334 14.6067C6.49334 14.8133 8.24667 14.5133 9.50667 13.36C10.8933 12.0733 11.4 10.02 10.6533 8.23335ZM4.46667 11.5867C5.42667 11.3533 5.92 10.66 6.05334 10.0467C6.27334 9.09335 5.41334 8.16001 5.99334 6.65335C6.21334 7.90001 8.17334 8.68001 8.17334 10.04C8.22667 11.7267 6.4 13.1733 4.46667 11.5867Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasFlame);
export default __webpack_public_path__ + "static/media/GasFlame.3d8b75356343716f1cd18fe52cca83dc.svg";
export { ForwardRef as ReactComponent };